import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchCollections } from '../../services/CollectionService';

const AllChannels = () => {
    const [collections, setCollections] = useState([])

    useEffect(() => {

        const loadCollections = async () => {
            try {
                const data = await fetchCollections(); // Use the API function
                setCollections(data);
            } catch (error) {
                console.error('Error loading Radio channels:', error);
            }
        };

        loadCollections();

    }, []);

    return (
        <main className="main">
            <div className="container-fluid">
                <section className="row row--grid">
                    <div className="col-12">
                        <div className="main__title">
                            <h2>All Channels</h2>
                        </div>
                    </div>

                    {collections.length === 0 ? (
                        <div className="col-12">
                            <p>No channels found.</p>
                        </div>
                    ) : (
                        collections.map((collection) => (
                            <div className="col-12 col-sm-6 col-lg-3" key={collection.id}>
                                <div className="post">
                                    <Link to={`/collection/${collection.slug}`} className="post__img">
                                        <img
                                            src={collection.image}
                                            alt=""
                                            className="img-fluid"
                                            style={{ width: '100%', height: '200px', objectFit: 'cover' }}
                                        />
                                    </Link>
                                    <div className="post__content">
                                        <Link to={`/collection/${collection.slug}`} className="text-white text-decoration-none">
                                            {collection.name}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </section>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="partners owl-carousel">
                        
                    </div>
                </div>
            </div>
        </main>
    );
};

export default AllChannels;
